type LogoSize = 'sm' | 'md' | 'lg';

interface LogoProps {
  size?: LogoSize;
  showWordmark?: boolean;
  className?: string;
}

/**
 * Brand logo with icon and optional wordmark.
 */
export function Logo({ size = 'md', showWordmark = true, className = '' }: LogoProps) {
  const { markClass, textClass } = getLogoClasses(size);

  return (
    <div className={`flex items-center gap-3 ${className}`} aria-label="VR Meet">
      <LogoMark className={markClass} />
      {showWordmark && <span className={`font-display ${textClass}`}>VR Meet</span>}
    </div>
  );
}

interface LogoMarkProps {
  className: string;
}

/**
 * Gradient icon used as the VR Meet mark.
 */
function LogoMark({ className }: LogoMarkProps) {
  return (
    <img
      src="/vrmeet_mark.png"
      alt=""
      className={`${className} object-contain`}
      aria-hidden="true"
    />
  );
}

/**
 * Returns class names for logo sizing.
 */
function getLogoClasses(size: LogoSize): { markClass: string; textClass: string } {
  if (size === 'sm') {
    return { markClass: 'h-9 w-9', textClass: 'text-lg' };
  }

  if (size === 'lg') {
    return { markClass: 'h-14 w-14', textClass: 'text-2xl' };
  }

  return { markClass: 'h-11 w-11', textClass: 'text-xl' };
}

/**
 * VR headset icon for the logo mark.
 */
